__turbopack_context__.v({
  "active": "tabs-module-scss-module__jRaZVa__active",
  "affirm": "tabs-module-scss-module__jRaZVa__affirm",
  "fullWidth": "tabs-module-scss-module__jRaZVa__fullWidth",
  "offerTab": "tabs-module-scss-module__jRaZVa__offerTab",
  "progressive": "tabs-module-scss-module__jRaZVa__progressive",
  "synchrony": "tabs-module-scss-module__jRaZVa__synchrony",
  "tab": "tabs-module-scss-module__jRaZVa__tab",
  "tablink": "tabs-module-scss-module__jRaZVa__tablink",
  "wrapper": "tabs-module-scss-module__jRaZVa__wrapper",
});
